import { createFileRoute } from '@tanstack/react-router';
import { CardNamePage } from '../components/pages/CardPage/CardNamePage';

export const Route = createFileRoute('/account/cards_/$cardId_/name')({
  component: CardNamePage,
});
